module.exports = __webpack_public_path__ + "img/scan.ab2ccc56.svg";